var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoveTo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.4,
    viewBox: "0 0 18 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MoveTo",
    transform: "translate(47.316 -711.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34547",
    "data-name": "Path 34547",
    d: "M-31.116,712.82h-7.2l-1.8-1.8h-5.4a1.805,1.805,0,0,0-1.8,1.8v10.8a1.817,1.817,0,0,0,1.8,1.8h14.4a1.811,1.811,0,0,0,1.8-1.8v-9A1.8,1.8,0,0,0-31.116,712.82Zm-7.209,9.9-1.278-1.269,1.431-1.431h-3.744v-1.8h3.744l-1.422-1.431,1.269-1.269,3.609,3.609Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveTo);
export default __webpack_public_path__ + "static/media/MoveTo.72078b059c8e3983948da1124c31e2f5.svg";
export { ForwardRef as ReactComponent };